import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import { storage } from "@/utils";
import router from "@/router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    
    _USA_SCHEDULE_LINKS:USA_SCHEDULE_LINKS,
    showStartupPopup:true,

    showLoadingLayer:false,

    localeRx: /^\w{2}-\w{2}$/,
    locale: 'en',//{ln: "",cc: "",name: "Global"},
    localizedUI:null,
    localizedUIReady: false,

    requestedPath: null,
    user: null,
    // >> LAYOUT >>
    showTopBar: false,
    // >> Orders >>
    loadingOrders: false,
    notifications:[],
    orders: [],
    order: {
      options: {},
      data: {}
    },
    // << Orders <<
    // >> Filters >>
    filters: {
      searchText: null,
      fromDate: null,
      toDate: null
    },
    statusFilter: null,
    timeRangeFilter: 1,
    typeFilter: 1,
    // << Filters <<
    // >> Responsive >>
    $device: "desktop",
    // << Responsive <<

    // >>> ORDER STATUS >>>
    statusList: [
      {
        id: 1,
        StatusName: "Created",
        StatusDesc: "Created",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        id: 12,
        StatusName: "Pending",
        StatusDesc: "Pending",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        id: 2,
        StatusName: "Planned",
        StatusDesc: "Planned",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        id: 3,
        StatusName: "Approved",
        StatusDesc: "Approved",
        IsShowDropBox: true,
        IsShowDashboard: true
      },

      {
        id: 11,
        StatusName: "Designed",
        StatusDesc: "Designed",
        IsShowDropBox: false,
        IsShowDashboard: true
      },
      {
        id: 22,
        StatusName: "In Production",
        StatusDesc: "In Production",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        id: 5,
        StatusName: "Shipped",
        StatusDesc: "Shipped",
        IsShowDropBox: true,
        IsShowDashboard: true
      },
      {
        id: 6,
        StatusName: "Cancelled",
        StatusDesc: "Cancelled",
        IsShowDropBox: false,
        IsShowDashboard: false
      },
      {
        id: 7,
        StatusName: "OnHold",
        StatusDesc: "On Hold",
        IsShowDropBox: false,
        IsShowDashboard: false
      },
      {
        id: 8,
        StatusName: "Done",
        StatusDesc: "Done",
        IsShowDropBox: false,
        IsShowDashboard: false
      },
      {
        id: 9,
        StatusName: "Rejected",
        StatusDesc: "Rejected",
        IsShowDropBox: true,
        IsShowDashboard: false
      },
      {
        id: 4,
        StatusName: "Produced",
        StatusDesc: "Produced",
        IsShowDropBox: true,
        IsShowDashboard: false
      }

      // {
      //   id: 10,
      //   StatusName: "Draft",
      //   StatusDesc: "Draft",
      //   IsShowDropBox: false,
      //   IsShowDashboard: false
      // }
    ]
    // <<< ORDER STATUS <<<
  },
  mutations: {
    HIDE_STARTUP_POPUP(state)
    {
      state.showStartupPopup = false;
    },
    SET_LOADING_LAYER(state,show)
    {
      state.showLoadingLayer = show;
    },
    SET_LOCALE(state, locale) {
        state.locale = locale;
        localStorage.setItem("MIS-locale",locale);
        //storage.set(`MIS-locale`, locale, localStorage);
    },    
    SET_LOCALIZED_UI(state, dict) {
      state.localizedUI = dict;
      state.localizedUIReady = true;
    },
    UNSET_LOCALIZED_UI(state) {
      state.localizedUIReady = false;
    },
    INIT_USER(state, user) {
      state.user = user;
    },
    UPDATE_DEVICE(state, device) {
      state.$device = device;
    },
    UPDATE_SHOW_TOP_BAR(state, bool) {
      state.showTopBar = bool;
    },
    SET_ORDER_LOADING(state, bool) {
      state.loadingOrders = bool;
    },
    SET_ORDERS_LIST(state, orders) {
      state.orders = orders;
    },
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications;
    },
    SET_ORDER_DATA(state, data) {
      state.order.data = data;
    },
    SET_ORDER_OPTIONS(state, options) {
      state.order.options = options;
    },
    // UPDATE FILTERS
    UPDATE_FILTERS(state, filters) {
      state.filters = filters;
    },
    UPDATE_TIMERANGE_FILTER(state, range) {
      state.timeRangeFilter = range;
    },
    UPDATE_TYPE_FILTER(state, type) {
      state.typeFilter = type;
    },
    UPDATE_STATUS_FILTER(state, status) {
      if (state.statusFilter === status) {
        state.statusFilter = null;
      } else {
        state.statusFilter = status;
      }
    },
    SAVE_REQUESTED_PATH(state, _path) {
      state.requestedPath = _path;
    }
  },
  actions: {
    hideStartupPopup({ commit,state,getters }) {
      commit("HIDE_STARTUP_POPUP");
    },
    setLocale({ commit,state,getters }, locale) {
      if(state.locale!=locale || state.localizedUI==null)
      {
        commit("SET_LOADING_LAYER", true);
        //loading:
        //https://mflow-do-dev.mis-implants.com/mflow/pageUI/en
        commit("SET_LOCALE", locale);
        var postURL = `${SERVER_API[ENV]}mflow/ui?ln=${locale}`;
        if(getters.userToken==undefined){
          postURL = `${SERVER_API[ENV]}mflow/uiAno?ln=${locale}`;
          //alert("need to call anonymouse controller");
        }

        //alert("loading:"+postURL);
        fetch(postURL, {method: "GET",headers: { t: getters.userToken, u: getters.userID }})
          .then(res => res.json())
          .then(response => {
            commit("SET_LOADING_LAYER", false);
            if (response.Message && response.Message.indexOf("error") > -1) {
            } else {
              //alert("ui lables loaded");
              //alert("loclize-set");
              commit("SET_LOCALIZED_UI", response);
              //commit("SET", response);
            }
          })
          .catch(err => err);
      }
    },

    // RESPONSIVE
    updateDevice({ commit }) {
      let winw = window.innerWidth;
      commit(
        "UPDATE_DEVICE",
        winw > 1440 ? "desktop" : winw < 816 ? "mobile" : "tablet"
      );
    },
    // >> Save last path incase of logged out.. return to requested path >>
    saveRequestedPath({ commit }, _path) {
      commit("SAVE_REQUESTED_PATH", _path);
    },
    setLoadingLayer({ commit }, show) {
      commit("SET_LOADING_LAYER", show);
    },
    
    // >> USER >>
    async initUser({ commit, state }, userLoginData) {
      // console.log("1 intiuSER :", userLoginData, state.user);
      if (userLoginData) {
        // console.log("1111 intiuSER :", userLoginData);
        commit("INIT_USER", userLoginData);
        return userLoginData;
      } else if (!state.user) {
        let user = storage.get(`MFLOW__userData`, localStorage);
        if (user) {
          let _u = JSON.parse(user);
          // console.log("2 initUSER :", _u);

          commit("INIT_USER", _u);
          return _u;
        }
      }
      return state.user;
    },
    userLogout() {
      console.log("router > ", router);
      storage.remove("MFLOW__userData", localStorage);
      storage.remove("MFLOW__userDataSchema", localStorage);
      storage.remove("MFLOW__orderOptions", localStorage);
      router.replace("/");
      window.location.reload();
      // commit("INIT_USER", null);
    },
    // << USER <<
    updateShowTopBar({ commit }, bool) {
      commit("UPDATE_SHOW_TOP_BAR", bool);
    },
    //NOTIFICATIONS
    loadNotifications({ commit, state, getters, dispatch }) 
    {
      if(getters.userID)
      {
        console.log("loading notifications now");
        var postURL = `${SERVER_API[ENV]}mflow/Notifications`;
        return fetch(postURL, {
          method: "GET",
          headers: { t: getters.userToken, u: getters.userID }
        })
          .then(res => res.json())
          .then(response => {
            if (response.Message && response.Message.indexOf("error") > -1) {
              //dispatch("userLogout");
            } else {
              commit("SET_NOTIFICATIONS", response);
            }
          })
          .catch(err => err);
      }
    },
    markNotificationsAsRead({ commit, state, getters, dispatch }, msgsIDs) 
    {            
      var vm = this;
      if(msgsIDs.length>0)
      {
        var body = JSON.stringify(msgsIDs);
        var postURL = `${SERVER_API[ENV]}mflow/Notifications`;
        return fetch(postURL, {body,method: "POST",headers: { t: getters.userToken, u: getters.userID }})
          .then(res => res.json())
          .then(response => {
            if (response.Message && response.Message.indexOf("error") > -1) {
              console.log("error -- markNotificationsAsRead");
              //dispatch("userLogout");
            } else {
              console.log("reloading notifications");
              //alert("reloading notifications !!!");
              dispatch("loadNotifications");
              //vm.loadNotifications();//reload notifications
            }
            commit("SET_ORDER_LOADING", false);
          })
          .catch(err => err);
      }
    },

    // >> ORDERS >>
    initOrdersList({ commit, state, getters, dispatch }, noLoading) {
      // console.log("IN INIT ORDERS LIST ", getters.userToken);

      var SearchParams = {
        order_type_id: 2, //0:MGUIDE,1:CADCAM
        is_archive: -1, //-1 all
        is_draft: -1 //-1 all
      };
      var body = JSON.stringify(SearchParams);
      var postURL = `${SERVER_API[ENV]}mflow/OrdersList`;

      if (!noLoading) {
        commit("SET_ORDER_LOADING", true);
      }
      return fetch(postURL, {
        body,
        method: "POST",
        headers: 
        { 
          t: getters.userToken, u: getters.userID,
          'pragma': 'no-cache',
          'cache-control': 'No-Store',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'x-token':getters.userToken,
          'x-mid':getters.userID
        }        
      })
        .then(res => res.json())
        .then(response => {
          // console.log("orderslist res resssss >> ", response);
          // TODO: a better response from the server,
          // detailing the error, so it's clear if the user token
          // has been expired.
          if (response.Message && response.Message.indexOf("error") > -1) {
            dispatch("userLogout");
          } else {
            commit("SET_ORDERS_LIST", response);
          }
          commit("SET_ORDER_LOADING", false);
        })
        .catch(err => err);
    },
    initOrder({ commit, getters }, vm) {
      let api = SERVER_API[ENV] + "mflow/OrderMguide";
      console.log("INITIALIZE EXISITNG ORDER");
      fetch(api, {
        method: "get",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "pragma": "no-cache",
          "cache-control": "No-Store",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          t: getters.userToken,
          u: getters.userID
        }
      })
        .then(function(response) {
          // console.log("RESPONS: ", response);
          return response.json();
        })
        .then(function(res) {
          console.log("order schema: res >>> ", res);
          if (res.Order) {
            commit("SET_ORDER_DATA", res.Order);
          }
          if (res.Options) {
            storage.set(`MFLOW__orderOptions`, res.Options, localStorage);

            commit("SET_ORDER_OPTIONS", res.Options);
          }
        })
        .catch(err => err);
    },
    initOrderOptions({ commit }, options) {
      commit("SET_ORDER_OPTIONS", options);
    },
    //LOCALIZATIONS
    async initLocalizedUI({ state, commit }) {
      commit("UNSET_LOCALIZED_UI");
      let api = SERVER_API[ENV] + "mflow/pageUi/en";
      return fetch(api, {method: "get",mode: "cors",cache: "no-cache",
        headers: {
          "pragma": "no-cache",
          "cache-control": "No-Store",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          t: getters.userToken,
          u: getters.userID
        }
      })
      .then(function(response) {
        if (response.statusText === "OK") {
          commit("SET_LOCALIZED_UI", response);
          return true;
        } else {return false;}
      })
      .catch(error => {
        console.error("Error:", error);return error;
      });
    return true;;
    },    
    async submitOrder({ getters, dispatch, state }, body) {
      // console.log("in submitOrder action");
      let api = SERVER_API[ENV] + "mflow/OrderMguide";
      return fetch(api, {
        method: "post",
        body,
        mode: "cors",
        cache: "no-cache",
        headers: {
          "pragma": "no-cache",
          "cache-control": "No-Store",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          t: getters.userToken,
          u: getters.userID
        }
      })
        .then(function(response) {
          // console.log("SUBMIT ORDR RESPONS: ", response);
          if (response.statusText === "OK") {
            dispatch("initOrdersList");
            return true;
          } else {
            return false;
          }
        })
        .catch(error => {
          console.error("Error:", error);
          return error;
        });
    },
    // << ORDERS <<
    // >> FILTERS >>
    updateFilters({ commit }, filters) {
      commit("UPDATE_FILTERS", filters);
    },
    updateTimeRangeFilter({ commit }, range) {
      commit("UPDATE_TIMERANGE_FILTER", range);
    },
    updateTypeFilter({ commit }, type) {
      commit("UPDATE_TYPE_FILTER", type);
    },
    updateStatusFilter({ commit }, status) {
      // console.log("updateStatusFilter >>", status);
      commit("UPDATE_STATUS_FILTER", status);
    }
    // << FILTERS <<
  },
  getters: {
    fullName(state) {
      let user = state.user;
      if (user) {
        return user._id ? user.firstName + " " + user.lastName : null;
      }
      return null;
    },
    userToken(state) {
      return state.user ? state.user.Token : null;
    },
    userID(state) {
      return state.user ? state.user.userID : null;
    },
    userType(state) {
      return state.user ? state.user.userType : null;
    },
    isDistributor(state) {
      if (state.user) {
        return state.user.userType === 3;
      }
      return false;
    },
    isMcenter(state) {
      if (state.user) {
        return state.user.userType === 5;
      }
      return false;
    },
    isDoctor(state) {
      let user = state.user;
      if (user) {
        return user.userType === 2;
      }
      return false;
    },
    filteredOrdersByType(state, getters) {
      let orders = state.orders;
      let t = state.typeFilter;
      // console.log("ORDERSLENGTH> ", orders.length);
      if (orders.length) {
        if (getters.isDistributor) {
          return _.filter(orders, item => {
            if (t === 3) {
              return item.IsArhive; //item.StatusID === 8 ||
            }
            return !item.IsDraft && !item.IsArhive;
          });
        }
        return _.filter(orders, item => {
          if (t === 3) {
            return item.IsArhive; //item.StatusID === 8 ||
          } else if (t === 2) {
            return item.IsDraft;
          } else {
            return !item.IsDraft && !item.IsArhive && item.StatusID !== 8;
          }
        });
      }
      return [];
    },
    minDate(state) {
      let r = state.timeRangeFilter;
      let d = null;
      switch (r) {
        case 1:
          d = moment().subtract(1, "week");
          break;
        case 2:
          d = moment().subtract(1, "month");
          break;
        case 3:
          d = moment().subtract(3, "month");
          break;
        case 4:
          d = moment().subtract(1, "year");
          break;
        default:
          d = moment().subtract(10, "year");//all time (10 years)
          break;
      }
      return new Date(d);
    },
    orderStatusList(state) {
      let s = state.statusList;
      return _.filter(s, status => status.IsShowDashboard);
    }
  },
  modules: {}
});


//dimensions.push(`${localize("h") + item.gingival_height + localize("mm")}`);
